var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2H18V1.5C18 1.10218 17.842 0.720644 17.5607 0.43934C17.2794 0.158035 16.8978 0 16.5 0V0C16.1022 0 15.7206 0.158035 15.4393 0.43934C15.158 0.720644 15 1.10218 15 1.5V2H9V1.5C9 1.10218 8.84196 0.720644 8.56066 0.43934C8.27936 0.158035 7.89782 0 7.5 0V0C7.10218 0 6.72064 0.158035 6.43934 0.43934C6.15804 0.720644 6 1.10218 6 1.5V2H5.5C4.04131 2 2.64236 2.57946 1.61091 3.61091C0.579463 4.64236 0 6.04131 0 7.5L0 18.5C0 19.9587 0.579463 21.3576 1.61091 22.3891C2.64236 23.4205 4.04131 24 5.5 24H18.5C19.9587 24 21.3576 23.4205 22.3891 22.3891C23.4205 21.3576 24 19.9587 24 18.5V7.5C24 6.04131 23.4205 4.64236 22.3891 3.61091C21.3576 2.57946 19.9587 2 18.5 2ZM18.5 21H5.5C4.83696 21 4.20107 20.7366 3.73223 20.2678C3.26339 19.7989 3 19.163 3 18.5V10H21V18.5C21 19.163 20.7366 19.7989 20.2678 20.2678C19.7989 20.7366 19.163 21 18.5 21Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceWhite);
export default __webpack_public_path__ + "static/media/serviceWhite.f6bb572addf9ce62a96afb65d4ee1b43.svg";
export { ForwardRef as ReactComponent };